<div class="contact-container">
    <form [formGroup]="contactForm" (ngSubmit)="submit()" *ngIf="contactForm" class="contact-form">
        <frg-form-input label="Motif" class="input-edit-mode" id="motif" type="ngSelect" [formGroup]="contactForm"
            [control]="contactForm.get('motif')" [selectValue]="motifs"></frg-form-input>
        <frg-form-input label="Message" class="input-edit-mode" id="message" type="textarea" nbRows="8"
            placeholder="Message..." [formGroup]="contactForm" [control]="contactForm.get('message')">
        </frg-form-input>
        <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">Envoyer</frg-button>
    </form>
</div>